import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// ثبت پلاگین‌ها فقط در مرورگر؛ روی سرور فقط ماژول ایمپورت می‌شود.
if (!import.meta.env.SSR) {
  gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollSmoother, SplitText);
}

/** منحنی مشترک ورودها: شروع تند، فرود نرم (همان --hero-ease در CSS) */
export const EASE_OUT = "expo.out";

export { gsap, ScrollSmoother, ScrollTrigger, SplitText, useGSAP };
